import permissionsSlice from "@pages/Administration/Permissions/store/permissionsSlice";
import rolesSlice from "@pages/Administration/Role/components/RolePages/Roles/store/rolesSlice";
import roleGroupsSlice from "@pages/Administration/Role/components/RolePages/RoleGroups/store/roleGroupsSlice";
import educationalInstitutionSlice from "@pages/Administration/EducationalInstitution/store/educationalInstitutionSlice";
import classroomsSlice from "@pages/Administration/EducationalInstitution/InstituteSettingsPages/pages/Classrooms/store/classroomsSlice";
import orientationSlice from "@pages/Administration/EducationalInstitution/InstituteSettingsPages/pages/ClassroomOrientation/store/orientationSlice";
import branchesSlice from "@pages/Administration/EducationalInstitution/InstituteSettingsPages/pages/Branches/store/branchesSlice";
import buildingsSlice from "@pages/Administration/EducationalInstitution/InstituteSettingsPages/pages/Buildings/store/buildingsSlice";
import userAccessSlice from "@pages/Administration/UserAccessControl/store/userAccessSlice";

export const administrationReducer = {
    permissions: permissionsSlice.reducer,
    roles: rolesSlice.reducer,
    roleGroups: roleGroupsSlice.reducer,
    institutions: educationalInstitutionSlice.reducer,
    classrooms: classroomsSlice.reducer,
    orientation: orientationSlice.reducer,
    branches: branchesSlice.reducer,
    buildings: buildingsSlice.reducer,
    userAccess: userAccessSlice.reducer,
};
